'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _isEqual = require('lodash/isEqual');var _isEqual2 = _interopRequireDefault(_isEqual);
var _OMCheckbox = require('../OMCheckbox/OMCheckbox');var _OMCheckbox2 = _interopRequireDefault(_OMCheckbox);
var _OMWindDirection = require('./OMWindDirection.scss');var _OMWindDirection2 = _interopRequireDefault(_OMWindDirection);
var _directionIcon = require('../../../../static/icons/direction-icon.png');var _directionIcon2 = _interopRequireDefault(_directionIcon);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

OMWindDirection = function (_Component) {_inherits(OMWindDirection, _Component);function OMWindDirection() {var _temp, _this, _ret;_classCallCheck(this, OMWindDirection);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.










    handleChange = function (event) {var _event$target =
      event.target,id = _event$target.id,checked = _event$target.checked;
      _this.props.changeValue('light_direction.' + id, checked);
    }, _this.

    renderField = function (side) {var
      lightDirection = _this.props.lightDirection;
      return _react2.default.createElement('div', { className: (0, _classnames2.default)(_OMWindDirection2.default.checkbox, _OMWindDirection2.default[side]) },
        _react2.default.createElement(_OMCheckbox2.default, {
          id: side,
          label: _this.props.translate(side),
          field: {
            value: side,
            onChange: _this.handleChange,
            checked: lightDirection ? lightDirection[side] : false } }));



    }, _temp), _possibleConstructorReturn(_this, _ret);}OMWindDirection.prototype.componentDidMount = function componentDidMount() {this.props.registerNewField('light_direction');};OMWindDirection.prototype.shouldComponentUpdate = function shouldComponentUpdate(_ref) {var lightDirection = _ref.lightDirection,locale = _ref.locale;var dataChanged = !(0, _isEqual2.default)(this.props.lightDirection, lightDirection);var localeChanged = this.props.locale !== locale;return dataChanged || localeChanged;};OMWindDirection.prototype.

  render = function render() {
    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)('form-group', _OMWindDirection2.default.directionButtons) },
        this.renderField('north'),
        this.renderField('east'),
        _react2.default.createElement('img', { src: _directionIcon2.default, className: _OMWindDirection2.default.directionIcon, alt: 'direction' }),
        this.renderField('south'),
        this.renderField('west')));


  };return OMWindDirection;}(_react.Component);exports.default = OMWindDirection;


OMWindDirection.propTypes = {
  translate: _propTypes2.default.func.isRequired,
  changeValue: _propTypes2.default.func.isRequired,
  registerNewField: _propTypes2.default.func.isRequired,
  lightDirection: _propTypes2.default.object,
  locale: _propTypes2.default.string };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMWindDirection/OMWindDirection.js
// module id = 2786
// module chunks = 0